export default "__VITE_ASSET__pMHGb9Zz__"